import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MySpaceConstants } from '../my-space-constants';
import { AuthenticationHelperService } from '../../shared/components/authentication-maintainance/services/authentication-helper.service';
import { EmployeesTrainingPlanService } from '../employees-training-plan/services/employees-training-plan.service';
import { EmployeesTrainingPlanConstants } from '../employees-training-plan/employees-training-plan.constants';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { DefaultValueConstants } from '../../shared/constants/default-value-constants';

@Component({
  selector: 'app-user-training-plan-review',
  templateUrl: './user-training-plan-review.component.html',
  styleUrls: ['./user-training-plan-review.component.scss']
})
export class UserTrainingPlanReviewComponent {
  @Input() selectedPuid: any = '';
  @Output() isModelOpen = new EventEmitter<boolean>();
  confirmationMessage: string = MySpaceConstants.TrainingPlanReview_Complete_Status_AcknowledgementMessage;
  heading: string = MySpaceConstants.TrainingPlanReview_Heading;
  reviewCommentValidationMessage: string = MySpaceConstants.TrainingPlanreview_ValidationMessage;

  reviewComment = '';  
  isModalVisable = true;
  isCommentForReviewRequired = false;

  constructor( private readonly authenticationHelperService: AuthenticationHelperService,  private changeDetectorRef: ChangeDetectorRef, private messageService: MessageService, 
    private employeesTrainingPlanService: EmployeesTrainingPlanService,) {
  }

 ngOnInit(): void {
 }

 updateTrainingPlanReview(){
  if(this.reviewComment.length > 0){
    this.authenticationHelperService.reauth(this.saveSignature.bind(this), this.closeConfirmationModal.bind(this));
  }
  else{
    this.isCommentForReviewRequired = true;
  }
}
 
 closeReasonDailog(){   
   this.isModelOpen.emit(false) 
 }
 
 onDialogHide(){
   this.isModelOpen.emit(false) 
 }
 

saveSignature(){
  this.isModelOpen.emit(false) 
    this.employeesTrainingPlanService.addTrainingPlanReviewWithStatusCompleted(this.selectedPuid, this.reviewComment)
    .pipe(
      catchError((err) => {
        this.messageService.add({
          severity: EmployeesTrainingPlanConstants.Severity_Err,
          summary: `${err.error}`,
        });
        this.changeDetectorRef.detectChanges();
        return throwError(() => err);
      })
    )
      .subscribe(serviceData =>{
        this.messageService.add({
          severity: EmployeesTrainingPlanConstants.Severity_Info,
          summary: EmployeesTrainingPlanConstants.UpdateTrainingPlanReview
        });
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
          const queryparam = 'activeTab'.concat('=', DefaultValueConstants.TabMyEmployees);
          const url = location.origin.concat(DefaultValueConstants.UserProfileUrlPath, queryparam);
          window.location.replace(url);
        }, 2000)
      });
}

closeConfirmationModal(){
  this.isModelOpen.emit(false) 
}


}
